import { useEffect } from "react";

import routes from "config/routes";

import useNavStore from "stores/useNavStore";
import useUserStore from "stores/useUserStore";

export default () => {
  const currentRoute = useNavStore(state => state.currentRoute);
  const navigate = useNavStore(state => state.navigate);

  const userRole = useUserStore(state => state.role);

  useEffect(() => {
    if (
      navigate &&
      currentRoute &&
      currentRoute.allowUsers &&
      !currentRoute.allowUsers.includes(userRole)
    ) {
      navigate(routes.error);
    }
  }, [currentRoute, navigate, userRole]);
}